import { BUTTON, IMAGE, PAGE, RECTANGLE, TEXT, VIDEO, SHAPE, LINE, SECTION, SECTION_COLUMN, FORM, FORM_STEP, FORM_FIELD, FORM_SUBMIT, FORM_NUMBER, FORM_TEXTAREA, FORM_CHECK_BOX, FORM_DROPDOWN_LIST, SEEK, FORM_CHECK_LIST, GROUP, HTML, IFRAME, LIVE_ELEMENT, LIVE_ELEMENT_CONTAINER, MENU_CONTAINER, MENU, MENU_DRAGGABLE_CONTAINER, CONTENT, CONTENT_CARD, BASIC_TEXT, CONTENT_PAGINATION_BUTTON, ASSET, CAROUSEL, CAROUSEL_CARD } from "constants/widgetTypes";
import { renderPageWidget } from "./rendererWidgets/page";
import { renderRectangleWidget } from "./rendererWidgets/rectangle";
import { renderButtonWidget } from "./rendererWidgets/button";
import { renderTextWidget } from "./rendererWidgets/text";
import { renderImageWidget } from "./rendererWidgets/image";
import { renderVideoWidget } from "./rendererWidgets/video";
import { renderShapeWidget } from "./rendererWidgets/shape";
import { renderLineWidget } from "./rendererWidgets/line";
import { renderSectionWidget } from "./rendererWidgets/section/section";
import { renderSectionColumnWidget } from "./rendererWidgets/section/column";
import { renderFormWidget } from "./rendererWidgets/form/form";
import { renderFormStepWidget } from "./rendererWidgets/form/formStep";
import { renderFormFieldWidget } from "./rendererWidgets/form/formField";
import { renderFormSubmitWidget } from "./rendererWidgets/form/formSubmit";
import { renderNumberFieldWidget } from "./rendererWidgets/form/numberField";
import { renderTextareaFieldWidget } from "./rendererWidgets/form/textArea";
import { renderBooleanFieldWidget } from "./rendererWidgets/form/checkBox";
import { renderDropdownFieldWidget } from "./rendererWidgets/form/dropdownList";
import { renderSeekWidget } from "./rendererWidgets/seek";
import { renderCheckboxFieldWidget } from "./rendererWidgets/form/checkBoxList";
import { renderGroupWidget } from "./rendererWidgets/group";
import { renderHtmlWidget } from "./rendererWidgets/html";
import { renderIFrameWidget } from "./rendererWidgets/iframe";
import { renderLiveElementWidget } from "./rendererWidgets/liveElement/liveElement";
import { renderLiveElementContainerWidget } from "./rendererWidgets/liveElement/liveElementContainer";
import { renderMenuWidget } from "./rendererWidgets/menu/menu";
import { renderMenuContainerWidget } from "./rendererWidgets/menu/menuContainer";
import { renderMenuDraggableContainerWidget } from "./rendererWidgets/menu/menuDraggableContainer";
import { renderContentWidget } from "./rendererWidgets/content/content";
import { renderContentCardWidget } from "./rendererWidgets/content/contentCard";
import { renderBasicTextWidget } from "./rendererWidgets/basicText";
import { renderAssetWidget } from "./rendererWidgets/asset";
import { renderCarouselWidget } from "./rendererWidgets/carousel/carousel";
import { renderCarouselCardWidget } from "./rendererWidgets/carousel/carouselCard";

import html2canvas from "html2canvas";

const context = {};

const renderers = {
    [PAGE] : renderPageWidget,
    [RECTANGLE] : renderRectangleWidget,
    [TEXT]: renderTextWidget,
    [BASIC_TEXT]: renderBasicTextWidget,
    [BUTTON]: renderButtonWidget,
    [IMAGE]: renderImageWidget,
    [VIDEO]: renderVideoWidget,
    [SHAPE]: renderShapeWidget,
    [LINE]: renderLineWidget,
    [SECTION]: renderSectionWidget,
    [SECTION_COLUMN]: renderSectionColumnWidget,
    [FORM]: renderFormWidget,
    [FORM_STEP]: renderFormStepWidget,
    [FORM_FIELD]: renderFormFieldWidget,
    [FORM_SUBMIT]: renderFormSubmitWidget,
    [FORM_NUMBER]: renderNumberFieldWidget,
    [FORM_TEXTAREA]: renderTextareaFieldWidget,
    [FORM_CHECK_BOX]: renderBooleanFieldWidget,
    [FORM_CHECK_LIST]: renderCheckboxFieldWidget,
    [FORM_DROPDOWN_LIST]: renderDropdownFieldWidget,
    [SEEK]: renderSeekWidget,
    [GROUP]: renderGroupWidget,
    [HTML]: renderHtmlWidget,
    [IFRAME]: renderIFrameWidget,
    [LIVE_ELEMENT]: renderLiveElementWidget,
    [LIVE_ELEMENT_CONTAINER]: renderLiveElementContainerWidget,
    [MENU]: renderMenuWidget,
    [MENU_CONTAINER]: renderMenuContainerWidget,
    [MENU_DRAGGABLE_CONTAINER]: renderMenuDraggableContainerWidget,
    [CONTENT]: renderContentWidget,
    [CONTENT_CARD]: renderContentCardWidget,
    [CONTENT_PAGINATION_BUTTON]: renderButtonWidget,
    [ASSET]: renderAssetWidget,
    [CAROUSEL]: renderCarouselWidget,
    [CAROUSEL_CARD]: renderCarouselCardWidget

};

export async function generateHTML(widgets, pageWidget, currentBreakpoint, storyboard) {
    const html = await fetch("/template.html").then(r => r.text());

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    context.document = doc;
    context.renderers = renderers;
    context.widgets = widgets;
    context.currentBreakpoint = currentBreakpoint;
    context.storyboard = storyboard;

    const parentElement = doc.querySelector("#html_renderer");
    if (!parentElement) {
        throw new Error("Could not find #viewer_renderer in template.html");
    }

    const renderer = renderers[pageWidget.type];
    if (!renderer) throw new Error("No renderer for widget type: " + pageWidget.type);
    
    await renderer(context, pageWidget, parentElement);

    return doc.documentElement.outerHTML;
}

export async function generateImageSnapshot(widget, breakpoint) {
    let widgetElement = null;

	if (breakpoint === "desktop") {
		widgetElement = document.querySelector(`.editor_device_preview #${widget.uid}`);
		if (!widgetElement) {
			console.error(`Could not find widget element for snapshot: ${widget.uid} in ${breakpoint} view`);
			return;
		}
	} else {
		widgetElement = document.getElementById(`${widget.uid}`);
		if (!widgetElement) {
			console.error(`Could not find widget element for snapshot: ${widget.uid} in ${breakpoint} view`);
			return;
		}
	}

    const previewContainer = widgetElement.closest(".editor_device_preview");

    if (breakpoint === "desktop" && previewContainer) {
        previewContainer.style.visibility = "visible";
    }

	const canvas = await html2canvas(widgetElement, {
        scale: 1,
        useCORS: true,
        backgroundColor: "#fff"
    });

    if (breakpoint === "desktop" && canvas) {
        previewContainer.removeAttribute("style");
    }

	return new Promise((resolve) => {
        canvas.toBlob((blob) => {
            if (!blob) throw new Error("Failed to create blob");
            const url = URL.createObjectURL(blob); 
    
            resolve(
                new File(
                    [blob],
                    `${breakpoint}-${widget.uid}.jpg`,
                    { type: "image/jpeg" }
                )
            );
        }, "image/jpeg", 0.85);
    });
}